import { motion } from "framer-motion";

import { Container } from "@/components/ui/Container";
import { Section } from "@/components/ui/Section";
import { HOME_INTRO } from "@/data/content";
import { fadeUp, viewportOnce } from "@/lib/motion";

export function BriefIntro() {
  return (
    <Section data-testid="home-intro-section">
      <Container>
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mx-auto max-w-3xl text-center"
        >
          {HOME_INTRO.title && (
            <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl text-balance">
              {HOME_INTRO.title}
            </h2>
          )}
          <div className="mt-6 space-y-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
            {HOME_INTRO.paragraphs.map((p) => (
              <p key={p.slice(0, 24)}>{p}</p>
            ))}
          </div>
        </motion.div>
      </Container>
    </Section>
  );
}
